import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [vw, setVw] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);

  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMob = vw < 1024;

  const sectionTitleStyle = {
    fontWeight: "600",
    fontSize: "22px",
    color: "#FFFFFF",
    marginBottom: "35px",
  };

  const itemStyle = {
    marginBottom: "12px",
    fontSize: "12px",
  };

  const itemLinkStyle = {
    color: "#fff",
    textDecoration: "none",
    fontSize: isMob ? "32px" : "16px",
    fontWeight: "400",
  };

  const linkHeadingStyle = {
    color: "#fff",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: isMob ? "35px" : "22px"
  };

  return (
    <footer style={{ backgroundColor: "#0D0F2B", color: "#fff" }}>
      {/* Footer Navigation */}
      <div style={{ padding: "50px 60px 180px", display: "flex", flexWrap: "wrap", gap: "40px" }}>
        {footerColumns.map((section) => (
          <div key={section.title} style={{ minWidth: isMob ? "400px" : "160px", flex: "1" }}>
            <div style={sectionTitleStyle}>
              <Link to={section.link} style={linkHeadingStyle}>
                {section.title}
              </Link>
            </div>
            {section.items.map((item, idx) => (
              <div key={idx} style={itemStyle}>
                <Link to={item.link} style={itemLinkStyle}>
                  {item.label}
                </Link>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Footer Bottom */}
      <div style={{ width: "95%", height: "1px", backgroundColor: "rgba(255,255,255,0.2)", margin: "20px auto", }} />
      <div style={{ padding: "0px 60px 30px 60px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ color: "#aaa", fontSize: isMob ? "32px" : "14px", marginBottom: isMob ? "0px" : "0px" }}>© 2022 Ravity
          <Link to="/privacy-policy" style={{ color: "#aaa", textDecoration: "underline", marginLeft: "20px", fontSize: isMob ? "32px" : "14px", }}>
            Privacy Policy
          </Link>
        </div>
        <img src="../img/RavityLogo.png" alt="Logo" style={{ width: isMob ? "80px" : "40px", height: isMob ? "80px" : "40px" }} />
      </div>
    </footer>
  );
};

const footerColumns = [
  {
    title: "Products",
    items: [
      { label: "Quality Intelligence", link: "/product/quality-intelligence" },
      { label: "Engineering Acceleration", link: "/product/engineering-acceleration" },
      { label: "Fleet Optimization", link: "/product/fleet-optimization" },
      { label: "Data Monetization", link: "/product/data-monetization" },
      { label: "Customer Experience", link: "/product/customer-experience" },
      { label: "Compliance & Sustainability", link: "/product/compliance-and-sustainability" },
    ],
  },
  {
    title: "Solutions",
    items: [
      { label: "Vehicle Engineering", link: "/solution/vehicle-engineering" },
      { label: "Sales & Marketing", link: "/solution/sales-and-marketing" },
      { label: "After Sales & Customer Experience", link: "/solution/after-sales-and-customer-service" },
      { label: "Fleet Management", link: "/solution/fleet-management" },
      { label: "Quality", link: "/solution/quality" },
      { label: "Regulatory & Sustainability", link: "/solution/regulatory-and-sustainability" },
    ],
  },
  {
    title: "Platforms",
    items: [
      { label: "Connected Mobility", link: "/platform/connected-mobility" },
      { label: "Sage AI", link: "/platform/sage-ai" },
      { label: "Agents of Mobility", link: "/platform/agents-of-mobility" },
    ],
  },
  {
    title: "Customers",
    items: [{ label: "Case Study", link: "/customers" }],
  },
  {
    title: "Company",
    items: [
      { label: "About Us", link: "/company/about-us" },
      { label: "Join Our Team", link: "/company/join-Our-team" },
    ],
  },
];

export default Footer;

